/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tysiav2PaymentOverdueStatus/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Tysiav2PaymentOverdueStatus({
  children,
  viewPath = "/DesignSystem/Svgs/Tysiav2PaymentOverdueStatus",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 10,
  height = 11,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2 = "#9AA5B1"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="Tysiav2PaymentOverdueStatus.Svg"
  data-view-path={viewPath}
 viewBox="0 0 10 11"
 style={{'--as-1-cREtE': alignSelf,'--mt-2-cREtE': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-cREtE': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-cREtE': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-cREtE': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-cREtE': opacity,'--w-10-cREtE': typeof width === 'number' ? `${width}px` : width,'--h-11-cREtE': typeof height === 'number' ? `${height}px` : height,'--f-12-cREtE': fill,'--a-7-cREtE': isAnimated ? animation : "none",'--sd-8-cREtE': isAnimated ? strokeDashoffset : 0,'--sd-9-cREtE': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="Tysiav2PaymentOverdueStatus.SvgPath"
  data-view-path={viewPath}
 fillRule="evenodd"
 clipRule="evenodd"
 d="M0 1.536C0 .946.497.5 1.071.5H8.93C9.503.5 10 .947 10 1.536v4c0 .126-.023.245-.064.355a3.213 3.213 0 00-5.042.68H1.071C.497 6.571 0 6.125 0 5.536v-4zm6.429 2a1.429 1.429 0 11-2.858 0 1.429 1.429 0 012.858 0zm-4.983.178a.536.536 0 111.072 0 .536.536 0 01-1.072 0zm6.572-.535a.536.536 0 100 1.07.536.536 0 000-1.07zm1.982 5a2.321 2.321 0 11-4.643 0 2.321 2.321 0 014.643 0zm-1.291-1.03a.446.446 0 010 .63l-.715.715a.446.446 0 11-.631-.631l.714-.714a.446.446 0 01.632 0z"
 style={{'--f-12-cREtE': fill2}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}